import { render, staticRenderFns } from "./SetAlarm.vue?vue&type=template&id=603b2658&scoped=true&"
import script from "./SetAlarm.vue?vue&type=script&lang=js&"
export * from "./SetAlarm.vue?vue&type=script&lang=js&"
import style0 from "./SetAlarm.vue?vue&type=style&index=0&id=603b2658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603b2658",
  null
  
)

export default component.exports